import React from "react";
import styled from "styled-components";
import Image from "next/image";

import Link from "../components/Link";
import * as T from "./Typography";

export default function getCollection(props) {
  return (
    <Link href={`/academy/collection/${props.urlSlug}`}>
      <S.Collection>
        <S.ImageWrapper>
          <Image
            src={props.courseCardImage.url}
            alt={props.courseCardImage.title}
            layout="fill"
            objectFit="cover"
          />
        </S.ImageWrapper>
        <T.H4>{props.courseName}</T.H4>
        <T.CM>{props.coursesCollection.total} courses</T.CM>
      </S.Collection>
    </Link>
  );
}

const S = {};

S.Collection = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  flex: 1;
  border-radius: 3px;
  :hover {
    opacity: 0.7;
  }
`;

S.ImageWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  height: 0;
  padding-top: 100%;
  display: flex;
  background: #eee;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
`;
